<ng-container *ngIf="occasionDatesErrors as occasionErrors">
    <ng-container *ngFor="let occasionError of occasionErrors | keyvalue">
        <div *ngFor="let message of occasionError.value" class="error-message">
            {{ message }}
        </div>
    </ng-container>
</ng-container>
<app-occasions-dates-manager
    class="slide-in-add-occasion"
    [dateOccasions]="resourceOccasionsFormArray"
    [onTheFly]="true"
></app-occasions-dates-manager>
